import { defineMessages } from 'react-intl';

import { StateEntryProps, ReadWriteType } from '.';

defineMessages({
  buttonText: {
    id: 'builder.nodes.BinarySorter.state.audioText',
    defaultMessage: 'Weiter',
  },
  leftTitle: {
    id: 'builder.nodes.BinarySorter.state.leftTitle',
    defaultMessage: 'Linker Titel',
  },
  rightTitle: {
    id: 'builder.nodes.BinarySorter.state.rightTitle',
    defaultMessage: 'Rechter Titel',
  },
});

export const binarySorterStateEntry: StateEntryProps = {
  type: 'renderBinarySorter',
  temporary: false, // TRUE as we implemented an explicit echo to remove the next button!
  payload: {
    getValuesFrom: [''],
    elements: [],
    buttonText: 'builder.nodes.BinarySorter.state.audioText',
    saveResultTo: 'binarySort',
    leftTitle: 'builder.nodes.BinarySorter.state.leftTitle',
    rightTitle: 'builder.nodes.BinarySorter.state.rightTitle',
    blindSpots: false,
    arrows: false,
  },
  getValueType: [ReadWriteType.stringArray, ReadWriteType.typedObject], // array +number
  saveResultType: ReadWriteType.typedObject,
  displayName: 'Binary Sorter',
  nodeType: 'binarySorterStateEntry',
  handleOutCount: 1,
};
